import React from 'react';
import { Card, Row, Badge, Col } from 'react-bootstrap';
import { processValue, getStatusHexColor } from '../Utils/generalUtil';
import s from '../UnitOverview.module.scss';
import get from 'lodash.get';

const TableStyle = ({ itemDetail }) => {
    return (
        <Card className="mb-4 py-3 px-4 shadow">
            <div className={` ${s.groupHeading} mb-3  fw-bold`}>{itemDetail.Name}</div>
            {itemDetail.Details.map(n => {
                return (
                    <TableRow key={n.UnitDashboardDetailId} itemDetail={n} />
                );
            })}
        </Card>
    );
};

export default TableStyle;


const TableRow = ({ itemDetail }) => {
    const processedValue = processValue(itemDetail.EvaluatedValue);
    return (

        <Row className="py-2 px-1 mb-3 mx-3 align-items-center border-bottom">
            <Col xs={5} className="text-muted">{itemDetail.Title}</Col>
            <Col xs={3}><strong>{`${processedValue} ${itemDetail.UoM}`}</strong></Col>
            <Col xs={4} >
                <div className={s.circle} style={{backgroundColor:getStatusHexColor(itemDetail.EvaluatedStatus)}}></div>
                {itemDetail.EvaluatedStatus}

            </Col>
        </Row>

    );
};